module.exports = __webpack_public_path__ + "static/media/Group 1517.a6096831.svg";